import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6a0a4e06&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6a0a4e06&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0a4e06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a0a4e06')) {
      api.createRecord('6a0a4e06', component.options)
    } else {
      api.reload('6a0a4e06', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6a0a4e06&scoped=true", function () {
      api.rerender('6a0a4e06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/add-class/index.vue"
export default component.exports